import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const DeliverableModalContainer = styled(Box, {
  name: 'deliverable-modal-container',
  slot: 'Root',
})(() => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  height: '80vh',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'var(--template-palette-background-default)',
  border: '2px solid #000',
  boxShadow:
    '0px 12px 24px 0px rgba(0, 0, 0, 0.2), 0px 16px 48px 0px rgba(0, 0, 0, 0.15)',
  padding: '16px 16px 8px 16px',
}));

export { DeliverableModalContainer };
